import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

type ColorBandProps = {
  children: ReactNode
  className?: string
  id?: string
}

type ColorBandInnerProps = {
  children: ReactNode
  className?: string
}

/** Full-bleed marketing band, same width/padding language as HeroShowcase. */
export function ColorBand({ children, className, id }: ColorBandProps) {
  return (
    <section
      id={id}
      className={cn(
        "relative overflow-hidden px-4 py-20 sm:px-6 sm:py-24 lg:py-28",
        className,
      )}
    >
      {children}
    </section>
  )
}

export function ColorBandInner({ children, className }: ColorBandInnerProps) {
  return (
    <div className={cn("relative mx-auto max-w-[96%] lg:max-w-[80%]", className)}>
      {children}
    </div>
  )
}
